import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
  import ProgressBar from '@/components/common/ProgressBar.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import { UserModule } from '@/store/modules/user'
  import useIcons from '@/composables/useIcons'
  import useSegment from '@/composables/useSegment'
  import eventBus from '@/main'
  import type { PropType } from 'vue'
  import type { GetStartedStepEntity } from '@/services/interfaces/Common'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PanelStepEmptyStateContent',
  props: {
    activeStep: {
      type: Number,
      required: true,
    },
    activeStepEntity: {
      type: String as PropType<GetStartedStepEntity>,
      required: true,
    },
    stepEmptyStateTitle: String,
    stepEmptyStateDescription: String,
    totalQuestionsAnsweredPercentage: Number,
    totalQuestionsAnswered: Number,
    stepVideoUrl: String,
    thumbnailTimestamp: Number,
    stepEmptyStateCTA: String,
  },
  setup(__props) {

const props = __props;

  

  const { arrowRight } = useIcons()
  const { companyOnboardingPopupClosed, getStartedVideoModalShown } = useSegment()
  const badgeLeftWidth = ref(0)

  const progressBarWidth = computed(() => {
    return `calc(100% -  ${props.totalQuestionsAnsweredPercentage === 100 ? badgeLeftWidth.value : 0}px`
  })

  const showStepModal = () => {
    getStartedVideoModalShown(props.activeStep, props.activeStepEntity)
    eventBus.$emit('show-modal', {
      modalContentComponent: 'GetStartedOnboardingModal',
      cssClass: 'get-started-onboarding-modal',
      modalProps: {
        videoUrl: props.stepVideoUrl || '',
        thumbnailTimestamp: props.thumbnailTimestamp,
        activeStepEntity: props.activeStepEntity,
      },
      modalCloseCallback: (callback: () => void) => {
        if (typeof callback === 'function') callback()
        companyOnboardingPopupClosed(UserModule.currentCompany!.id)
      },
    })
  }

return { __sfc: true,props, arrowRight, companyOnboardingPopupClosed, getStartedVideoModalShown, badgeLeftWidth, progressBarWidth, showStepModal, computed, ref, ProgressBar, SVGRenderer, KetchUpButton, UserModule, useIcons, useSegment, eventBus }
}

})